<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<h1 class="Heading-1" id="_idParaDest-4"><a id="_idTextAnchor004"></a>Acknowledgments</h1>
<p class="Prelims-prose">So many ought to be thanked, I should have to write another book, nearly the length of this one.</p>
<p class="Prelims-prose">Some, however, must be thanked.</p>
<p class="Prelims-prose">I am the beneficiary of instruction and criticism from four writers, whom I can never repay except by writing better the next time. William Logan, Robert R. Morgan, Padgett Powell, and Robert B. Shaw have chastened and improved my skills and my strivings with wisdom and good cheer in equal measure. My own cantankerousness alone is responsible for the many failings that remain.</p>
<p class="Prelims-prose">Then there are those who have cared in spite of everything. I will always remember Jacqueline and Judson Allen, Jay Arns, Amy Atkinson, Tony Borden, Peter and Janet Brav, Margaret Bridges, Claire Brown, Ron Burrichter, Bob Butler, Beckett Cantley, Rebecca Davis, Kay Dunlap, Helen Egger, Dylan Fay, Justin Forti, Lee Foster, Will Goodman, Karen Greenberg, Michael Harrawood, Steve Kent, Lindsay and Travis LaJoie, Mark Lane, Brett C. Millier, Jimmy Newlin, Jonathan Newman, G. Michael Palmer, Ralph S. Smith, John Summerfield, Sandra Weems.</p>
<p class="Prelims-prose">My family are the light in my eyes—Brian, Elaine, Judy, Michelle, and Oliver.</p>
<p class="Prelims-prose">The man to whom I dedicate this book was my teacher and my model for teaching during my 43 years in the classroom. I only wish I had lived up to his example.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781645367314_EPUB-4.vue?1190973b